// Zwei Listen, die ein Deck-Fenster neu holen muss, wenn dasselbe Deck anderswo verändert
// wurde. Sie stehen hier an einer Stelle, weil zwei Auslöser sie brauchen — der
// Fokus-Refetch (`useRefetchOnWindowFocus`) und der Fenster-Abgleich
// (`useDeckSyncChannel`); getrennt gepflegt liefen sie auseinander und ein Fenster bliebe
// je nach Auslöser auf einem anderen Stand.
import { DECK_SUGGESTIONS_ROOT_KEY } from '../catalog/useDeckSuggestions';
import { deckCategoriesKey } from '../utils/deckIds';

/**
 * Fokus-Refetch: Deck, Wantlist und Kategorien. Ohne Vorschläge, weil jede Rückkehr ins
 * Fenster sonst eine Scoring-Anfrage auslöst; die Vorschlagsliste bleibt bis zur nächsten
 * eigenen Mutation stehen (Spec §6.4).
 *
 * @param {import('@tanstack/react-query').QueryClient} queryClient
 * @param {number|null} [numericDeckId] - numerische Deck-ID für die Kategorie-Query;
 *   ohne sie (Deck noch nicht geladen) bleibt nur diese eine Invalidierung aus.
 */
export function invalidateDeckViews(queryClient, numericDeckId) {
  queryClient.invalidateQueries({ queryKey: ['deck-editor'] });
  queryClient.invalidateQueries({ queryKey: ['deck'] });
  // Die Wantlist-Zeile der Brücke rechnet aus derselben Deck-Änderung: eine drüben
  // hinzugefügte Karte verschiebt „fehlt noch" — ohne sie stünde die Zeile auf dem
  // Stand vor dem Add, während die Karte darüber schon im Deck liegt.
  queryClient.invalidateQueries({ queryKey: ['wantlist'] });
  if (numericDeckId != null) {
    queryClient.invalidateQueries({ queryKey: deckCategoriesKey(numericDeckId) });
  }
}

/**
 * Fenster-Abgleich: dasselbe Deck wurde anderswo verändert, der Deckinhalt ist neu — auch
 * die Vorschläge.
 *
 * @param {import('@tanstack/react-query').QueryClient} queryClient
 * @param {number|null} [numericDeckId]
 */
export function invalidateDeckViewsAfterRemoteChange(queryClient, numericDeckId) {
  invalidateDeckViews(queryClient, numericDeckId);
  queryClient.invalidateQueries({ queryKey: [DECK_SUGGESTIONS_ROOT_KEY] });
}

export default invalidateDeckViews;
